import { render } from "./creatSpaceView.vue?vue&type=template&id=d8845cf2&scoped=true&ts=true"
import script from "./creatSpaceView.vue?vue&type=script&lang=ts"
export * from "./creatSpaceView.vue?vue&type=script&lang=ts"

import "./creatSpaceView.vue?vue&type=style&index=0&id=d8845cf2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8845cf2"]])

export default __exports__